module.exports = __webpack_public_path__ + "img/Phone_04.31aa5d45.jpg";